import { NarrativeCommunityList } from '../components/NarrativeCommunityList';
import { useTracking } from 'react-tracking';
import { useMount } from '@simplywallst/ui-core';

export const NarrativeCommunity = () => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
  });
  useMount(() => {
    trackEvent({ subject: 'page', action: 'landed' });
  });

  return (
    <Track>
      <div className="w-full max-w-screen-xl p-x2 lg:p-x3 grid gap-x2">
        <h1 className="text-xl font-bold text-solid m-0">
          Community Narratives
        </h1>

        <NarrativeCommunityList />
      </div>
    </Track>
  );
};
